import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import Cookies from 'universal-cookie'
import http from '../plugins/axios'
import { decodeText } from '../plugins/encrypt'

const cookies = new Cookies()

export const getCredential = createAsyncThunk('auth/getCredential', async () => {
  const session = cookies.get('manage-session')
  let responseCredential = ''
  if (session !== undefined) {
    responseCredential = session
  } else {
    responseCredential = 'invalid-token'
  }
  return responseCredential
})

const authData = createSlice({
  name: 'auth',
  initialState: {
    authorization: null,
    isLogin: false,
    isLoading: true,
  },
  reducers: {
    updateDataLogin: (state, action) => {
      state.authorization = action.payload.authorization
      state.isLogin = action.payload.isLogin
      state.isLoading = action.payload.isLoading
    }
  },
  extraReducers: {
    [getCredential.pending]: (state) => {
      state.isLoading = true
    },
    [getCredential.fulfilled]: (state, action) => {
      if (action.payload !== 'invalid-token') {
        const decodeSession = decodeText(action.payload)
        const parsedData = JSON.parse(decodeSession)
        http.defaults.headers.common['Authorization'] = `Bearer ${parsedData.access_token}`  
        state.isLogin = true
        state.authorization = parsedData
        state.isLoading = false
      } else {
        cookies.remove('manage-session')
        state.isLogin = false
        state.authorization = null
        state.isLoading = false
      }
    },
    [getCredential.rejected]: (state) => {
      state.isLoading = false
      state.isLogin = false
      state.authorization = null
    }
  }
})

export const { updateDataLogin } = authData.actions
export default authData.reducer